import Preview from "./Preview";

const Pages = {
  Preview,
};

export default Pages;
